module.exports = __webpack_public_path__ + "static/media/checked.4cd0d106.png";